
import { Space } from "antd";
import SpButton from "../../../sp-components/SpButton/SpButton";
import transactionInitImage from '../../../assets/images/service_interruption.png';
import { redirectAfterDelay } from "../../../utils/utils";

const ServiceInterruption = ({transactionReference}) => {
  
    return (
        <div style={{
            backgroundColor: '#fff',
            padding: "1.2rem 2rem",
            borderRadius: 12,
            marginTop: 16,
        }}>

            <div style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                minHeight: '33vh',
                textAlign: 'center',
                padding: "2rem 2rem",

            }}>

                <div style={{ marginBottom: 24 }}>
                    <img src={transactionInitImage} alt='' style={{
                        maxWidth: "205px"
                    }} />
                </div>
                <h4 style={{
                    fontSize: 20,
                }}>Service Interruption</h4>
                <p 
                    style={{
                        color: "#696969",
                        maxWidth: "320px",
                        fontSize: 14,
                        textAlign: "center"
                    }}
                >
                    The service provider is currently down.<br /> 
                    We will retry your payment and send your token within the next 24 hours.
                </p>

                    <div style={{ marginTop: 40 }}>
                        <Space>
                            <SpButton onClick={() => {
                                //navigate('/')
                            }}>
                                Retry
                            </SpButton>

                            <SpButton type="outline" onClick={() => {
                                redirectAfterDelay('/');
                            }}>
                                Back to Home
                            </SpButton>
                        </Space>
                    </div>
            </div>
        </div>
    );
};

export default ServiceInterruption;
